module.exports = __webpack_public_path__ + "img/use-in-defi.43a078d3.png";